import React, { useState } from 'react';
import './FooterLinks.css';
import FooterLink from './FooterLink';

export function FooterLinks({
  title = '',
  items = [],
  className = '',
  columns = '2',
  hideLinkText = false,
  inlineLinks = false,
}) {
  const [showContent, setShowContent] = useState(false);
  const footerToggleList = showContent ? 'showFooterLinks' : '';
  const inlineLinksClassName = inlineLinks ? 'inlineFooterLinks' : '';
  const footerToggleIcon = showContent ? 'rotatePlus' : '';

  const toggleContent = (e) => {
    e.stopPropagation();
    setShowContent((prevState) => !prevState);
  };

  return (
    <div className={`footerLinksWrapper ${className}`}>
      {title && (
        <div className="footerTitle">
          {title}
          <span className={`footerToggle ${footerToggleIcon}`} role="button" onClick={toggleContent}>
            +
          </span>
        </div>
      )}
      <ul className={`footerLinks has-${columns}-columns ${footerToggleList} ${inlineLinksClassName}`}>
        {items.map((item, index) => (
          <FooterLink key={index} {...item} hideLinkText={hideLinkText} />
        ))}
      </ul>
    </div>
  );
}
